module.exports = __webpack_public_path__ + "static/devops-8f6efd4e2168ebe0269399c0d3e86121.jpg";